import NewHeader_dev from "../components_en/NewHeader_dev";
import MainVanner_dev from "../components_en/MainVanner_dev";
import Footer from "../components/Footer";
import HomeCSS from "./Home_dev.module.css";
import Loader from "../components/Loader";
import React, {useState, useEffect} from 'react'

function Home() {
  return (
    <div className={HomeCSS.base}>
      <div className={HomeCSS.ref}>
        {/* <img src="img/Home.png" alt="ex" /> */}
      </div>
      <div>
        <NewHeader_dev />
        <div>
        <div className={HomeCSS.content}>
          <MainVanner_dev />
        </div>
        <br />
        <br />
        <Footer />
      </div>
        
    </div>
      {/*<div className={HomeCSS.underConsruction}>
        <img className={HomeCSS.background} src="img/main_underConstruction.jpg"/>
      </div>*/}
    </div>
  );
}
export default Home;
